export default __webpack_public_path__ + "static/media/businessImg1.afaabf23.jpg";